import { useIsMobile } from '../../hooks/useIsMobile'
import './Roadmap.css'

const PHASES = [
    {
        title: 'PHASE I — INCUBATION',
        period: '2025–2035',
        milestones: [
            {
                year: '2025',
                title: 'The First Spark',
                status: 'completed',
                summary: '$LIGHTER launched on TON via Blum Memepad.',
                highlights: [
                    'Bonding curve completed, migrated to STON.fi DEX',
                    'Community of early believers formed',
                    'lighter-coin.com published',
                    'The Auauauau origin story entered the world',
                ],
            },
            {
                year: '2026',
                title: 'Proof of Fire',
                status: 'in-progress',
                summary: 'Heyoo Telegram Mini App enters beta. 10,000 QR-stickered lighters flood the streets.',
                highlights: [
                    'Scan a QR-stickered lighter, connect your wallet, receive your first flame',
                    'Traveling Flame protocol — lighters don\'t get lost, they migrate',
                    'Flame Map awakens — a living visual record of where fire has traveled',
                    'Heyoo Telegram Mini App beta launch',
                ],
                note: 'FIRE SEEDERS — THE FORGOTTEN ONES: 200M tokens reserved for 20,000 Forgotten Ones. Trained distributors find those living below the poverty line — 10,000 $LIGHTER per person. Prometheus stole fire from the gods. We give it to the people the world forgot.',
            },
            {
                year: '2027',
                title: 'Territory Ignition',
                summary: 'City-wide expansion begins. Two factions rise.',
                highlights: [
                    'Inter-district territory wars ignite across the hex map',
                    'Check-in mechanics go live at partner venues',
                    'Cafés, barbershops, gyms & restaurants appear on the Flame Map with profiles',
                    'NFT lighters minted as on-chain artifacts',
                    'Denetçi (Auditor) program & Fire Council (Ateş Konseyi) launch',
                    'First KOBİ partnerships — real-world perks to zone controllers',
                    'Fire Seeders program expands nationwide',
                ],
            },
            {
                year: '2028',
                title: 'The Living Map',
                summary: 'Heyoo evolves from a game into a daily tool.',
                highlights: [
                    'Venue menus & price lists visible in-app',
                    'Reservation system — book a barber chair, café table, gym slot via Flame Map',
                    'KOBİ dashboard: foot traffic, customer behavior, campaign performance',
                    'Businesses create location-based promotions, pay only when users show up',
                    '$LIGHTER becomes a payment method at partner venues',
                    'First Lighter Social House opens — barbershop, bioproduction & community point',
                ],
            },
            {
                year: '2029',
                title: 'The Smart Flame',
                summary: 'First smart lighters enter production: GPS, NFC, BLE-enabled titanium devices.',
                highlights: [
                    'Hardware identity: NFC chip carrying a private key that proves it\'s real',
                    'Tap your lighter to your phone — signs transactions & verifies location',
                    'Proof-of-physical-presence broadcast to the network',
                    'The blockchain doesn\'t live inside the lighter — the lighter is what makes it worth running',
                ],
            },
            {
                year: '2030',
                title: 'The Sovereign Chain',
                summary: 'Engin launches in beta — a decentralized task operating system.',
                highlights: [
                    'Engin: decentralized task OS built on Lighter infrastructure',
                    'Second Social House opens',
                    'Thousands of smart lighters form a distributed identity layer',
                    'Foundation Series: first 100 genesis lighters with full on-chain provenance',
                ],
            },
            {
                year: '2035',
                title: 'Critical Mass',
                summary: 'The Lighter network spans multiple countries. The fire feeds itself.',
                highlights: [
                    'Cross-border flame chains light up across continents',
                    'Flame Map is now a full commerce layer — discover, book, pay, earn',
                    'Hundreds of thousands of smart lighters form mobile proof-of-presence infrastructure',
                    'Self-sustaining loop: physical distribution → user acquisition → venue commerce → token utility',
                ],
            },
        ],
    },
    {
        title: 'PHASE II — THE NETWORK',
        period: '2035–2060',
        milestones: [
            {
                year: '2035–2040',
                title: 'Replication',
                summary: 'Social House model replicates across multiple regions.',
                highlights: [
                    'Each house: community anchor — part barbershop, part bioproduction, part flame keeper',
                    'Every lighter sold, given, or lost adds another identity anchor to the mesh',
                    'Engin scales to a full decentralized work marketplace',
                    'Fire Seeders program operates autonomously through DAO governance',
                    'Flame Map becomes the default way to discover local businesses in Lighter Districts',
                ],
            },
            {
                year: '2045',
                title: 'Lighter Guild Credits',
                summary: 'Work credentials earned through the Lighter ecosystem gain recognition.',
                highlights: [
                    'Guild Credits: verifiable proof of contribution, skill & community trust',
                    'Recognized by major regional employers',
                    'Validated by a network no government or corporation controls — a million pockets',
                ],
            },
            {
                year: '2050',
                title: 'The Lighter Stablecoin',
                summary: 'LSC launches — pegged to a commodity basket, not fiat.',
                highlights: [
                    'Hundreds of thousands of physical identity devices anchor the network',
                    'Settlement layer for a parallel economy',
                    'The Forgotten Ones who received stickers decades ago hold generational wealth',
                    'The most human blockchain on earth — every node authenticated by an object you can hold',
                ],
            },
        ],
    },
    {
        title: 'PHASE III — THE CITADEL',
        period: '2060–2100',
        milestones: [
            {
                year: '2060',
                title: 'Lighter Districts',
                summary: 'DAO-governed autonomous zones emerge — physical territories on Lighter protocol.',
                highlights: [
                    'The hex map that began as a game, became commerce, now administers real neighborhoods',
                    'Community decisions, resource allocation & local commerce flow through the network',
                ],
            },
            {
                year: '2080',
                title: 'Post-Scarcity Transition',
                summary: 'Fully automated biological production across the Social House network.',
                highlights: [
                    'Supply chains built for lighter distribution now produce essentials',
                    'Infrastructure that once booked barbershop appointments now allocates resources for communities',
                ],
            },
        ],
    },
    {
        title: 'PHASE IV — GALACTIC HORIZON',
        period: '2100–2125',
        milestones: [
            {
                year: '2100',
                title: 'The Archive',
                summary: 'The original Social House transforms into a living museum.',
                highlights: [
                    'Lighter protocol powers 20% of regional economic activity',
                    'Chain of human testimony becomes humanity\'s most extraordinary collective document',
                    'Behind glass sits a plastic Bic with a faded QR sticker — the first flame',
                ],
            },
            {
                year: '2125',
                title: 'The Eternal Flame',
                summary: 'The lighter was never lost. It traveled.',
                highlights: [
                    'Closed-loop Standard Operating Protocols exported to lunar & Martian colonies',
                    'Born from a sticker on a disposable lighter in 2026 — now validates transactions on other worlds',
                    'The fire that burned 1.7 million years ago now burns where no river has ever flowed',
                ],
            },
        ],
    },
]

export const Roadmap = () => {
    const isMobile = useIsMobile()
    let cardIndex = 0

    return (
        <div className='page-container'>
            <h2 className='roadmap-section-title fire-title'>The Century Roadmap</h2>
            <div className='roadmap-subtitle'>
                From a single spark to an eternal flame.
            </div>

            <div className='page-content-container'>
                {PHASES.map((phase) => (
                    <div key={phase.title}>
                        <div className='chapter-title-bar'>
                            {phase.title} · {phase.period}
                        </div>
                        {phase.milestones.map((milestone) => {
                            const side = !isMobile ? (cardIndex % 2 === 0 ? 'left' : 'right') : ''
                            const isCompleted = milestone.status === 'completed'
                            const highlights = isCompleted ? [...milestone.highlights].reverse() : milestone.highlights
                            cardIndex++
                            return (
                                <div
                                    key={milestone.year}
                                    className={`page-item ${side}`}>
                                    <div className='page-content'>
                                        <div className='roadmap-milestone'>
                                            <div className='roadmap-year-row'>
                                                <span className='roadmap-year'>{milestone.year}</span>
                                                {milestone.status === 'completed' && (
                                                    <span className='roadmap-status roadmap-status-done'>COMPLETED</span>
                                                )}
                                                {milestone.status === 'in-progress' && (
                                                    <span className='roadmap-status roadmap-status-active'>IN PROGRESS</span>
                                                )}
                                            </div>
                                            <h3 className='roadmap-milestone-title'>{milestone.title}</h3>
                                            <p className='roadmap-summary'>{milestone.summary}</p>
                                            <ul className={`roadmap-highlights ${isCompleted ? 'roadmap-highlights-completed' : ''}`}>
                                                {highlights.map((h, i) => (
                                                    <li key={i}>{h}</li>
                                                ))}
                                            </ul>
                                            {milestone.note && (
                                                <blockquote className='roadmap-note'>{milestone.note}</blockquote>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                ))}
            </div>
        </div>
    )
}
